import { Component } from 'react';
import { connect } from 'react-redux';
import { AppState } from "../../util/store/store";
import { ACTION } from "../../util/varibles/permission";
import Menu from "./Component/Menu";
import { KEY_PREFERENCE } from "./Component/Menu/constants";
import WrapperContent from "./Component/WrapperContent";
import CertaintyOperation from "./Content/CertaintyOperation";
import ConfigurePlan from "./Content/ConfigurePlan";
import CustomizeHarvestOperation from "./Content/CustomizeHarvest";
import SetArrivalTime from "./Content/SetArrivalTime";
import SubscribeEmail from "./Content/SubscribeEmail";
import VesselCrewApp from "./Content/VesselCrewApp";
import ViewModes from "./Content/ViewModes";
import styles from "./style.module.scss";

const mapStateToProps = (state: AppState) => ({
    permission: state.login.user.permission
});

interface IProps {
    permission: any
}

class PreferencePage extends Component<IProps> {
    menu: any = [];

    state = {
        focusId: KEY_PREFERENCE.CUSTOMIZE_HARVEST,
        content: {}
    }

    constructor(props: IProps) {
        super(props);
        const { permission } = this.props;

        if (permission[ACTION.PREFERENCE.PLAN]) {
            this.menu.push({
                label: 'Plan operation',
                id: KEY_PREFERENCE.PLAN_OPERATION,
                type: 'group',
                isOpen: true,
                tab: ''
            });
            if (permission[ACTION.PREFERENCE.HARVEST_CUSTOMIZE])
                this.menu.push({
                    label: 'Customize harvest operation',
                    id: KEY_PREFERENCE.CUSTOMIZE_HARVEST,
                    type: 'item',
                    isOpen: false,
                    tab: '',
                    render: () => <CustomizeHarvestOperation />
                });

            if (permission[ACTION.PREFERENCE.OP_CERTAIN])
                this.menu.push({
                    label: 'Set operation\'s certainty',
                    id: KEY_PREFERENCE.CERTAINTY_OPERATION,
                    type: 'item',
                    isOpen: false,
                    tab: '',
                    render: () => <CertaintyOperation />
                });

            if (permission[ACTION.PREFERENCE.WORK_TIME])
                this.menu.push({
                    label: 'Set arrival time at site / factory',
                    id: KEY_PREFERENCE.SET_ARRIVAL_TIME,
                    type: 'item',
                    isOpen: false,
                    tab: '',
                    render: () => <SetArrivalTime />
                });

            if (permission[ACTION.PREFERENCE.CONFIGURE_PLAN])
                this.menu.push({
                    label: 'Auto plan configure',
                    id: KEY_PREFERENCE.CONFIGURE_PLAN,
                    type: 'item',
                    isOpen: false,
                    tab: '',
                    render: () => <ConfigurePlan />
                });
        }

        if (permission[ACTION.PREFERENCE.VESSEL_APP])
            this.menu.push({
                label: 'Vessel crew app',
                id: KEY_PREFERENCE.VESSEL_CREW_APP,
                type: 'item',
                isOpen: false,
                tab: '',
                render: () => <VesselCrewApp />,
            });

        if (permission[ACTION.PREFERENCE.MODE])
            this.menu.push({
                label: 'View modes',
                id: KEY_PREFERENCE.MODE_VIEWS,
                type: 'item',
                isOpen: false,
                tab: '',
                render: () => <ViewModes actions={permission} />,
            });
        if (permission[ACTION.SUBSCRIBE_EMAIL.VIEW])
            this.menu.push({
                label: `Subscribe completed operation's email`,
                id: KEY_PREFERENCE.SUBSCRIBE_EMAIL,
                type: 'item',
                isOpen: false,
                tab: '',
                render: () => <SubscribeEmail actions={permission} />,
            });

        const { id = '', render = () => null } = this.menu.find((item: any) => item.type === 'item') || {};
        this.state = { focusId: id, content: { [id]: render() } };
    }


    changeMenuItem = (menu: any) => {
        const { id: focusId } = menu;
        const { content }: any = this.state;
        if (content[focusId])
            this.setState({ focusId })
        else {
            const { render } = menu;
            this.setState({ focusId, content: { ...content, [focusId]: render() } })
        }
    }

    render() {
        const { focusId, content }: any = this.state;

        return <div className="m-header bgPage">
            <div className='header-page'>
                <div className='title-page'>
                    <span className='font-w2 mr-1'>Setting:</span>
                    <b>Preference</b>
                </div>
            </div>
            <div className='body-page scroll-small'>
                <div className={styles['wrapper-content']}>
                    <Menu
                        menu={this.menu}
                        focusId={focusId}
                        changeMenuItem={(focusId: any) => this.changeMenuItem(focusId)}
                    />
                    <WrapperContent>
                        {Object.keys(content).map(key => <div key={key} {...{
                            className: styles.content,
                            style: key === focusId ? {} : { display: 'none' }
                        }}>
                            {content[key]}
                        </div>)}
                    </WrapperContent>
                </div>
            </div>
            <div id='weather-suggestions' className={styles.menu} />
        </div>;
    }
}

export default connect(mapStateToProps, {})(PreferencePage);
